import { useParams } from 'react-router-dom';
import { GenericDrawer } from '@dealstack/frontend/shared/components/GenericDrawer/GenericDrawer';
import { useTranslationAdminDashboard } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { Classifier } from '@dealstack/frontend/app/pages/Project/DealSettings/Classifiers/types';
import { DrawerBodyEdit } from '@dealstack/frontend/app/pages/Project/DealSettings/Classifiers/EditClassifierDrawer/DrawerBodyEdit';
import { useGetDealClassifiers } from '@dealstack/frontend/app/pages/Project/DealSettings/Classifiers/hooks/useGetDealClassifiers';
import { getAllClassifiersFilter } from '@dealstack/frontend/app/pages/Project/DealSettings/Classifiers/EditClassifierDrawer/utils';

interface Props {
	classifier: Classifier;
	showCreateUpdateClassificationDrawer: boolean;
	handleOnCancel: () => void;
}

export const EditClassifierDrawer = ({
	classifier,
	showCreateUpdateClassificationDrawer,
	handleOnCancel,
}: Props) => {
	const tAdminDashboard = useTranslationAdminDashboard();
	const { dealId } = useParams();

	const { classifiers: availableClassifiers } = useGetDealClassifiers(
		getAllClassifiersFilter(dealId ?? '')
	);

	return (
		<GenericDrawer
			onClose={handleOnCancel}
			opened={showCreateUpdateClassificationDrawer}
			title={tAdminDashboard('drawer.classifier.title')}
			body={DrawerBodyEdit({
				classifier,
				availableClassifiers: availableClassifiers?.payload?.dealClassifiers,
				handleOnCancel,
			})}
		/>
	);
};
